import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GamificationCardsService } from '../../../services/gamification-cards.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-top-most-categories',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule,MatProgressSpinnerModule, FormsModule, NgMultiSelectDropDownModule, MatCardModule, MatTableModule, MatSelectModule, MatInputModule, MatFormFieldModule, MatPaginatorModule, MatSortModule, MatDividerModule],
  templateUrl: './top-most-categories.component.html',
  styleUrl: './top-most-categories.component.scss'
})
export class TopMostCategoriesComponent {
  displayedColumns: string[] = [
      'rank', 'category','prompts','users','usage', 'average_time_saved', 'average_rating'
  ];
  sort_order: string = 'desc';
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator = {} as MatPaginator;
  totalRecords: any = 0;
  pageSize: number = 20;
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 20];
  pageNumbers: number[] = [];
  topCategory: any;
  searchtextData: string = '';
  search_text: string = '';
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  usageAscSort: boolean = true;
  usageDesSort: boolean = false;
  sort_by: string = '';
  isLoading:boolean=false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly dialogRef: MatDialogRef<TopMostCategoriesComponent>,
      private readonly gamificationService: GamificationCardsService,
      private readonly dialog: MatDialog,
    ){
  
    }

    ngOnInit() {
      this.getTopCategoryPrompts();
    }


    getTopCategoryPrompts() {
      this.isLoading=true;
      const params: any = {
        start_date: this.data.start_date,
        end_date: this.data.end_date,
        search_text: this.search_text,
        limit: this.pageSize,
        offset: (this.pageSize * this.pageIndex),
        sort_order: this.sort_order,
        count: false
      };

     this.gamificationService.getTopCategories(params).subscribe({
        next: (resp:any) => {
          this.isLoading=false;
          this.topCategory = resp?.data?.data;
          this.dataSource = JSON.parse(JSON.stringify(this.topCategory));
          this.totalRecords = resp?.data?.total;
          const totalPages = Math.ceil(this.totalRecords / this.pageSize);
          this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i);
        },error: (err:any) => {
            this.isLoading=false;
            this.openSnackbar(err?.error?.message, 'An error occurred', 'error-snackbar');
        }
      });
    }

    onPageChange(event: any) {
     
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.getTopCategoryPrompts();
    }

    onPageChangeFromDropdown(event: any) {
     
      
      this.pageIndex = event.value;
      this.getTopCategoryPrompts();
    }

    onSearchChange() {
      if (this.searchtextData == '') {
        this.search_text = this.searchtextData;
        this.getTopCategoryPrompts();
      }
    }

    searchData(data:any) {
      if(data == '') {
        return
      } else {
        this.search_text = data;
        this.pageIndex = 0;
        this.getTopCategoryPrompts();
      }
    }

    clearSearch() {
      if (this.searchInput) {
        this.searchtextData = '';
        this.search_text = '';
        this.pageIndex = 0;
        this.getTopCategoryPrompts();
      }
    }

    sortingByAsc(sortColumn:any) {
      this.pageIndex = 0;
      if (sortColumn == 'usage') {
        this.usageAscSort = false;
        this.usageDesSort = true;
        this.sort_order = 'asc';
        this.getTopCategoryPrompts();
      }
    }

    sortingByDes(sortColumn:any) {
      this.pageIndex = 0;
      if (sortColumn == 'usage') {
        this.usageDesSort = false;
        this.usageAscSort = true;
        this.sort_order = 'desc';
        this.getTopCategoryPrompts();
      }
    }

    closeDialog() {
      this.dialogRef.close();
    }

    public formatTimeString(timeStr:string) {
      const [hoursStr, minsStr] = timeStr.split(':');
      const hours = parseInt(hoursStr, 10) || 0; // Ensure 0 if NaN
      const mins = parseInt(minsStr, 10) || 0;   // Ensure 0 if NaN
  
      return `${hours} hr ${mins} min`; // Always includes both units
    }

    openSnackbar(message: string, title: string, cssClass: string) {
       this.dialog.open(ErrorNotficationComponent, {
        data: {
          message: message,
          title: title,
          action_type: 'add',
          cssClass: cssClass,
        },
      });
    }
}

